export enum PortType {
    Door = "Door",
    Emergency = "Emergency",
    ClubLights = "ClubLights",
    Assist = "Assist",
    FireReset = "FireReset",
}
